module.exports = __webpack_public_path__ + "img/fly.7c85a01e.svg";